/* v6-quickadd.js — Ajax cart add for v6 product cards.
   Listens to form.v6-pcard__quickadd-form submissions, posts to /cart/add.js with
   the cart-drawer section bundle, then emits the theme's eventBus signals to
   re-render and open the cart drawer. */

(function () {
  function findEventBus() {
    return (typeof window !== 'undefined' && window.eventBus) ? window.eventBus : null;
  }

  async function quickAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    var originalLabel = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
      var fd = new FormData(form);
      // Ask Shopify to render the cart-drawer section in the response so the drawer can update without a page reload.
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);

      var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      var data = await res.json();

      if (!res.ok) {
        console.error('v6-quickadd: cart add failed', data);
        if (btn) btn.textContent = data.description || 'Could not add';
        setTimeout(function () { if (btn) { btn.textContent = originalLabel; btn.disabled = false; } }, 1800);
        return;
      }

      var bus = findEventBus();
      if (bus) {
        // The theme's CartDrawer component listens on these events; data.sections holds the rendered HTML.
        bus.emit('update:cart:drawer', data);
        bus.emit('open:cart:drawer');
      } else {
        // Fallback: navigate to /cart so the user sees what they just added.
        window.location.href = '/cart';
        return;
      }

      if (btn) {
        btn.textContent = 'Added ✓';
        setTimeout(function () { if (btn) { btn.textContent = originalLabel; btn.disabled = false; } }, 1400);
      }
    } catch (err) {
      console.error('v6-quickadd error', err);
      if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('v6-pcard__quickadd-form')) {
      e.preventDefault();
      quickAdd(f);
    }
  });

  // v6-cardd (Dame-pattern card from Brief #34): same /cart/add.js POST, but the
  // button has nested spans so we toggle data-state instead of clobbering textContent.
  async function dameCardAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.setAttribute('data-state', 'adding'); btn.disabled = true; }
    try {
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      var data = await res.json();
      if (!res.ok) {
        console.error('v6-cardd add failed', data);
        if (btn) { btn.setAttribute('data-state', 'error'); btn.disabled = false; }
        setTimeout(function () { if (btn) btn.removeAttribute('data-state'); }, 1800);
        return;
      }
      var bus = findEventBus();
      if (bus) {
        bus.emit('update:cart:drawer', data);
        bus.emit('open:cart:drawer');
      }
      if (btn) {
        btn.setAttribute('data-state', 'added');
        setTimeout(function () { if (btn) { btn.removeAttribute('data-state'); btn.disabled = false; } }, 1400);
      }
    } catch (err) {
      console.error('v6-cardd add error', err);
      if (btn) { btn.removeAttribute('data-state'); btn.disabled = false; }
    }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('v6-cardd__form')) {
      e.preventDefault();
      dameCardAdd(f);
    }
  });

  // Mega menu hover behavior — scoped per wrap, no document-level capture.
  function initMegamenu(wrap) {
    var panels = wrap.querySelectorAll('[data-v6-megamenu]');
    function closeAll() {
      panels.forEach(function (p) { p.setAttribute('data-open', 'false'); });
    }
    // Any link in the nav row (NOT one inside a panel) drives open/close behavior on hover.
    wrap.querySelectorAll('a').forEach(function (link) {
      if (link.closest('[data-v6-megamenu]')) return; // skip links that are panel content
      link.addEventListener('mouseenter', function () {
        var triggerId = link.getAttribute('data-v6-megamenu-trigger');
        closeAll();
        if (triggerId) {
          var p = wrap.querySelector('[data-v6-megamenu="' + triggerId + '"]');
          if (p) p.setAttribute('data-open', 'true');
        }
      });
    });
    // Close only when the cursor truly exits the entire wrap (panels are children of the wrap, so traveling
    // trigger → bridge → panel doesn't trigger this; only leaving the nav rectangle does).
    wrap.addEventListener('mouseleave', closeAll);
    // ESC key dismisses any open panel
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  document.querySelectorAll('[data-v6-megamenu-wrap]').forEach(initMegamenu);

  // v6 Filter drawer (Brief #35) — mobile bottom-sheet open/close
  document.addEventListener('click', function (e) {
    var openBtn  = e.target.closest('[data-v6-filter-open]');
    var closeBtn = e.target.closest('[data-v6-filter-close]');
    if (openBtn) {
      var d = document.querySelector('[data-v6-filter-drawer]');
      if (d) { d.hidden = false; document.body.style.overflow = 'hidden'; }
    } else if (closeBtn) {
      var d2 = document.querySelector('[data-v6-filter-drawer]');
      if (d2) { d2.hidden = true; document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = document.querySelector('[data-v6-filter-drawer]');
      if (d && !d.hidden) { d.hidden = true; document.body.style.overflow = ''; }
    }
  });

  // ===== PDP — Brief #43 =====
  initPDP();

  function initPDP() {
    var section = document.querySelector('[data-wetheme-section-type="main-product-v6"]');
    if (!section) return;

    // Parse variants
    var variants = [];
    var vNode = section.querySelector('[data-v6-pdp-variants]');
    if (vNode) {
      try { variants = JSON.parse(vNode.textContent); } catch (e) { console.error('v6-pdp: variants JSON parse failed', e); }
    }

    // ---- Gallery: thumb swap + hover preview + Brief #51 Task E swipe/keyboard ----
    var mainWrap = section.querySelector('[data-v6-pdp-main-wrap]');
    var mainImg  = section.querySelector('[data-v6-pdp-main]');
    var countEl  = section.querySelector('[data-v6-pdp-count]');
    var thumbs   = section.querySelectorAll('[data-v6-pdp-thumb]');
    var dots     = section.querySelectorAll('[data-v6-pdp-dot]');
    var currentIdx = 0;
    var FADE_MS = 160;

    function swapTo(idx, opts) {
      opts = opts || {};
      var t = thumbs[idx];
      if (!t || !mainImg || idx < 0 || idx >= thumbs.length) return;
      var big = t.getAttribute('data-src-1200');
      var full = t.getAttribute('data-src-2000');

      // Brief #57 Task A — synchronous state updates first (count, dots, thumb-active,
      // currentIdx). Guarantees programmatic dispatchEvent('click') sees the new state
      // on the next synchronous tick (per the verification mandate).
      thumbs.forEach(function (x) { x.classList.remove('v6-pdp__thumb--active'); });
      t.classList.add('v6-pdp__thumb--active');
      dots.forEach(function (d, di) { d.classList.toggle('v6-pdp__dot--active', di === idx); });
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + thumbs.length;
      currentIdx = idx;

      if (!big) return;
      mainImg.alt = t.getAttribute('data-alt') || '';

      // Brief #58 Task A — image swap driven by the LOAD event, not setTimeout.
      // Previous setTimeout-based crossfade left is-fading stuck when the new image
      // load was slower than 160ms. Now: set src immediately, listen for load
      // (fires when the browser has decoded the new image and naturalWidth > 0),
      // then remove is-fading so the CSS transition reveals the decoded image.
      // On error, remove is-fading anyway so the UI isn't stuck. srcset and full
      // attributes update in the same step so the browser picks the right size.
      if (opts.instant || !mainWrap) {
        mainImg.src = big;
        if (full) mainImg.setAttribute('data-full', full);
        return;
      }

      mainWrap.classList.add('is-fading');

      function onLoad() {
        mainImg.removeEventListener('load', onLoad);
        mainImg.removeEventListener('error', onError);
        requestAnimationFrame(function () { mainWrap.classList.remove('is-fading'); });
      }
      function onError() {
        mainImg.removeEventListener('load', onLoad);
        mainImg.removeEventListener('error', onError);
        if (window.console) console.warn('v6-pdp: image failed to load', big);
        mainWrap.classList.remove('is-fading');
      }
      mainImg.addEventListener('load', onLoad);
      mainImg.addEventListener('error', onError);

      // Clear srcset so the browser picks up the new src cleanly without fighting the
      // old srcset (the responsive variant resolver can otherwise resolve to a stale
      // cached entry and never fire 'load').
      mainImg.removeAttribute('srcset');
      mainImg.src = big;
      if (full) mainImg.setAttribute('data-full', full);

      // Safety net: if the load event never fires within 2 seconds, force-remove
      // is-fading so the UI doesn't get stuck. This catches edge cases like cached
      // images that complete synchronously without firing load, or network stalls.
      setTimeout(function () {
        if (mainWrap.classList.contains('is-fading')) {
          mainWrap.classList.remove('is-fading');
        }
      }, 2000);
    }
    function advance(delta) {
      if (!thumbs.length) return;
      var next = (currentIdx + delta + thumbs.length) % thumbs.length;
      swapTo(next);
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { swapTo(i); });
      t.addEventListener('mouseenter', function () { swapTo(i, { instant: true }); });
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { swapTo(i); });
    });

    // Touch swipe on the main image wrap (mobile-first; trackpad gestures also fire touch events on macOS Safari).
    if (mainWrap && thumbs.length > 1) {
      var touchStartX = 0, touchStartY = 0, touchStartT = 0, touchActive = false;
      mainWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartT = Date.now();
        touchActive = true;
      }, { passive: true });
      mainWrap.addEventListener('touchmove', function (e) {
        if (!touchActive) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        // If user is clearly scrolling vertically, bail out of swipe gesture.
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 20) touchActive = false;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dt = Math.max(1, Date.now() - touchStartT);
        var v = Math.abs(dx) / dt; // px per ms
        // Threshold: 40px AND (clear horizontal intent OR fast flick velocity).
        if (Math.abs(dx) >= 40 && (v >= 0.3 || Math.abs(dx) >= 80)) {
          if (dx < 0) advance(1); else advance(-1);
        }
      }, { passive: true });

      // Keyboard arrow keys when the main image wrap has focus.
      mainWrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { advance(-1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { advance(1);  e.preventDefault(); }
      });
    }

    // ---- Brief #56 Task A — inline prev/next arrows on the main image ----
    var prevBtn = section.querySelector('[data-v6-pdp-prev]');
    var nextBtn = section.querySelector('[data-v6-pdp-next]');
    function attachNav(btn, delta) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();   // don't fall through to main-image lightbox open
        e.preventDefault();
        advance(delta);
      });
    }
    attachNav(prevBtn, -1);
    attachNav(nextBtn, 1);

    // ---- Lightbox ----
    var lb     = section.querySelector('[data-v6-pdp-lightbox]');
    var lbImg  = section.querySelector('[data-v6-pdp-lightbox-img]');
    var lbCnt  = section.querySelector('[data-v6-pdp-lightbox-count]');
    var lbIdx  = 0;
    function openLB(idx) {
      if (!lb) return;
      lbIdx = idx;
      var t = thumbs[idx];
      if (t && lbImg) {
        lbImg.src = t.getAttribute('data-src-2000') || t.getAttribute('data-src-1200');
        lbImg.alt = t.getAttribute('data-alt') || '';
        if (lbCnt) lbCnt.textContent = (idx + 1) + ' / ' + thumbs.length;
      }
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeLB() {
      if (!lb) return;
      lb.hidden = true;
      document.body.style.overflow = '';
      // Brief #51 — sync the inline gallery to whichever image the user landed on in the lightbox.
      if (typeof lbIdx === 'number' && lbIdx !== currentIdx) swapTo(lbIdx, { instant: true });
    }
    function navLB(delta) {
      if (!thumbs.length) return;
      lbIdx = (lbIdx + delta + thumbs.length) % thumbs.length;
      openLB(lbIdx);
    }
    var lbOpenBtn  = section.querySelector('[data-v6-pdp-lightbox-open]');
    var lbCloseBtn = section.querySelector('[data-v6-pdp-lightbox-close]');
    var lbPrevBtn  = section.querySelector('[data-v6-pdp-lightbox-prev]');
    var lbNextBtn  = section.querySelector('[data-v6-pdp-lightbox-next]');
    if (lbOpenBtn) lbOpenBtn.addEventListener('click', function () { openLB(currentIdx); });
    if (mainImg)   mainImg.addEventListener('click', function () { if (thumbs.length > 1) openLB(currentIdx); });
    if (lbCloseBtn) lbCloseBtn.addEventListener('click', closeLB);
    if (lbPrevBtn) lbPrevBtn.addEventListener('click', function () { navLB(-1); });
    if (lbNextBtn) lbNextBtn.addEventListener('click', function () { navLB(1); });
    document.addEventListener('keydown', function (e) {
      if (lb && !lb.hidden) {
        if (e.key === 'Escape') closeLB();
        if (e.key === 'ArrowLeft') navLB(-1);
        if (e.key === 'ArrowRight') navLB(1);
      }
    });
    // Brief #51 — touch swipe inside the lightbox.
    if (lb && lbImg) {
      var lbStartX = 0, lbStartY = 0, lbStartT = 0, lbActive = false;
      lbImg.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        lbStartX = e.touches[0].clientX;
        lbStartY = e.touches[0].clientY;
        lbStartT = Date.now();
        lbActive = true;
      }, { passive: true });
      lbImg.addEventListener('touchmove', function (e) {
        if (!lbActive) return;
        var dy = e.touches[0].clientY - lbStartY;
        var dx = e.touches[0].clientX - lbStartX;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 20) lbActive = false;
      }, { passive: true });
      lbImg.addEventListener('touchend', function (e) {
        if (!lbActive) return;
        lbActive = false;
        var dx = e.changedTouches[0].clientX - lbStartX;
        var v = Math.abs(dx) / Math.max(1, Date.now() - lbStartT);
        if (Math.abs(dx) >= 40 && (v >= 0.3 || Math.abs(dx) >= 80)) {
          if (dx < 0) navLB(1); else navLB(-1);
        }
      }, { passive: true });
    }

    // ---- Variant resolver ----
    var form = section.querySelector('[data-v6-pdp-form]');
    var variantIdEl = section.querySelector('[data-v6-pdp-variant-id]');
    var priceEl = section.querySelector('[data-v6-pdp-price]');
    var atcPriceEl = section.querySelector('[data-v6-pdp-atc-price]');
    var atcBtn = section.querySelector('[data-v6-pdp-atc]');
    var atcLabel = section.querySelector('[data-v6-pdp-atc-label]');
    var mobileAtcPrice = section.querySelector('[data-v6-pdp-mobile-atc-price]');

    function resolveVariant() {
      var selected = [];
      var optionInputs = section.querySelectorAll('[data-v6-pdp-option]:checked');
      optionInputs.forEach(function (i) { selected.push(i.value); });
      // Also update the visible "selected" label per option
      section.querySelectorAll('[data-v6-pdp-option]').forEach(function (i) {
        if (i.checked) {
          var f = i.closest('.v6-pdp__option');
          if (!f) return;
          var legend = f.querySelector('legend .v6-pdp__option-selected');
          if (legend) legend.textContent = i.value;
        }
      });
      // Find matching variant
      var match = variants.find(function (v) {
        return v.options.every(function (opt, j) { return opt === selected[j]; });
      });
      if (!match) match = variants[0];
      if (!match) return;
      if (variantIdEl) variantIdEl.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_money;
      if (atcPriceEl) atcPriceEl.innerHTML = match.price_money;
      if (mobileAtcPrice) mobileAtcPrice.innerHTML = match.price_money;
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (atcLabel) atcLabel.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
    section.querySelectorAll('[data-v6-pdp-option]').forEach(function (i) {
      i.addEventListener('change', resolveVariant);
    });

    // ---- Quantity buttons (Brief #53 Task A — clamped 1..99, change-event clamp on type) ----
    var qtyInput = section.querySelector('.v6-pdp__qty-input');
    var QTY_MIN = 1;
    var QTY_MAX = 99;
    function clampQty(n) { n = parseInt(n, 10); if (!n || isNaN(n) || n < QTY_MIN) return QTY_MIN; if (n > QTY_MAX) return QTY_MAX; return n; }
    section.querySelectorAll('[data-v6-qty]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-v6-qty'), 10) || 0;
        var n = parseInt(qtyInput.value, 10) || QTY_MIN;
        qtyInput.value = clampQty(n + d);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); });
      qtyInput.addEventListener('blur', function () { qtyInput.value = clampQty(qtyInput.value); });
    }

    // ---- AJAX add-to-cart ----
    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (atcBtn) atcBtn.setAttribute('data-state', 'adding');
        try {
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer');
          fd.append('sections_url', window.location.pathname);
          var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          var data = await res.json();
          if (!res.ok) {
            if (atcBtn) { atcBtn.setAttribute('data-state', 'error'); }
            console.error('v6-pdp add failed', data);
            setTimeout(function () { if (atcBtn) atcBtn.removeAttribute('data-state'); }, 1800);
            return;
          }
          var bus = findEventBus();
          if (bus) { bus.emit('update:cart:drawer', data); bus.emit('open:cart:drawer'); }
          if (atcBtn) {
            atcBtn.setAttribute('data-state', 'added');
            if (atcLabel) atcLabel.textContent = 'Added ✓';
            setTimeout(function () {
              if (atcBtn) atcBtn.removeAttribute('data-state');
              if (atcLabel) atcLabel.textContent = 'Add to cart';
            }, 1600);
          }
        } catch (err) {
          console.error('v6-pdp add error', err);
          if (atcBtn) atcBtn.removeAttribute('data-state');
        }
      });
    }

    // ---- Mobile sticky bottom ATC: show after scrolling past info column ----
    var mobAtc = section.querySelector('[data-v6-pdp-mobile-atc]');
    var infoCol = section.querySelector('.v6-pdp__col-info');
    if (mobAtc && infoCol && window.matchMedia('(max-width: 999px)').matches) {
      var trigger = section.querySelector('[data-v6-pdp-mobile-atc-trigger]');
      if (trigger) trigger.addEventListener('click', function () {
        // Scroll back to ATC + flash it
        var atcAnchor = section.querySelector('.v6-pdp__atc');
        if (atcAnchor) atcAnchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      function onScroll() {
        var rect = infoCol.getBoundingClientRect();
        if (rect.bottom < 0) {
          mobAtc.setAttribute('data-visible', 'true');
        } else {
          mobAtc.removeAttribute('data-visible');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // ---- Initial variant sync ----
    resolveVariant();
  }
})();
